import React from "react";
import {
  iClinicProfile,
  generalInfoSchema,
  therapeuticApproachSchema,
  aboutClinicSchema,
  profileImagesSchema,
} from "ps-shared";
import { FormikWizard } from "src/components/Forms/FormikWizard";
import { GeneralInfoForm } from "src/components/My/Profiles/Forms/Clinic/GeneralInfo";
import ProfileImages from "src/components/My/Profiles/Forms/ProfileImages";
import TherapeuticApproach from "src/components/My/Profiles/Forms/Clinic/TherapeuticApproach";
import AboutClinic from "src/components/My/Profiles/Forms/Clinic/AboutClinic";
import { toast } from "react-toastify";
import { navigate } from "gatsby";
import { ProfileManageMode } from "src/models/ProfileManageMode";
import { ProfileWizardCbData, ProfileWizardCbResult } from "src/components/My/Profiles/ProfileWizard";

export interface ClinicProfileWizardProps {
  profile: iClinicProfile;
  mode: ProfileManageMode;
  submitCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
  nextCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
}
interface ClinicProfileWizardState {
  formInit: any;
}

export default class ClinicProfileWizard extends React.Component<ClinicProfileWizardProps, ClinicProfileWizardState> {
  private wizRef = React.createRef<FormikWizard>();

  constructor(props: ClinicProfileWizardProps) {
    super(props);
    const clinicForm = generalInfoSchema
      .concat(profileImagesSchema)
      .concat(therapeuticApproachSchema)
      .concat(aboutClinicSchema)
      .cast();
    if (this.props.mode === ProfileManageMode.edit) {
      // convert the server record to clinic profile
      Object.keys(this.props.profile).forEach((prop: string) => {
        // eslint-disable-next-line no-prototype-builtins
        if (this.props.profile[prop] !== undefined && clinicForm.hasOwnProperty(prop)) {
          (clinicForm as any)[prop] = this.props.profile[prop];
        }
      });
    }
    this.state = {
      formInit: clinicForm,
    };
  }

  public cancel() {
    navigate("/my/profiles/");
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormikWizard
          ref={this.wizRef}
          initialValues={this.state.formInit}
          validationSchemas={[generalInfoSchema, aboutClinicSchema, profileImagesSchema, therapeuticApproachSchema]}
          mode={this.props.mode}
          onCancel={() => {
            this.cancel();
          }}
          onSubmit={(values: any) => {
            return new Promise<void>((resolve, reject) => {
              this.props
                .submitCb({ values, page: undefined })
                .then(() => {
                  resolve();
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
          onNext={(values: any, page: number): Promise<ProfileWizardCbResult> => {
            return new Promise((resolve, reject) => {
              this.props
                .nextCb({ values, page })
                .then((result) => {
                  return resolve(result);
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
        >
          <FormikWizard.Page name="General Info">
            {(values: any) => (
              <div>
                <GeneralInfoForm values={values} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="About your Clinic">
            {(values: any) => (
              <div>
                <AboutClinic values={values} profile={this.props.profile} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Images">
            {(values: any) => (
              <div>
                <ProfileImages values={values} slug={values.slug} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Therapeutic Approach">
            {(values: any) => <TherapeuticApproach values={values} />}
          </FormikWizard.Page>
        </FormikWizard>
      </>
    );
  }
}
